import { CurbZonePageModeType } from "@/modules/curb-zone/curb-zone.type";
import { ModifyMode, RotateMode, TranslateMode } from "@deck.gl-community/editable-layers";
import { TransformIcon, MoveIcon, RotateIcon } from "components/icons";
import { EditorModeListType } from "./editor-mode-list.type";

export const editorModeList: EditorModeListType = {
  [CurbZonePageModeType.Edit]: [
    {
      label: "Modify",
      mode: ModifyMode,
      icon: <TransformIcon />,
    },
    {
      label: "Rotate",
      mode: RotateMode,
      icon: <RotateIcon />,
    },
    {
      label: "Move",
      mode: TranslateMode,
      icon: <MoveIcon />,
    },
  ],
  [CurbZonePageModeType.MultiEdit]: [
    {
      label: "Rotate",
      mode: RotateMode,
      icon: <RotateIcon />,
    },
    {
      label: "Move",
      mode: TranslateMode,
      icon: <MoveIcon />,
    },
  ],
};
